"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTagRatingSlider = exports.RatingSlider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("@src/types");
const styled_breakpoints_1 = require("styled-breakpoints");
const react_styled_1 = require("styled-breakpoints/react-styled");
exports.RatingSlider = (0, styled_components_1.default)(antd_1.Slider) `
	width: 100%;
	.ant-slider-mark-text {
		font-size: 0.7rem;
	}
`;
const SkillTagRatingSlider = ({ defaultValue, onChange, value, tagId }) => {
    const min = 1;
    const max = 5;
    const intl = (0, react_intl_1.useIntl)();
    const isLgOrHigher = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.up)('lg'));
    const marks = {
        1: intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.beginner}` }),
        2: isLgOrHigher
            ? intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.basics}` })
            : '',
        3: isLgOrHigher
            ? intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.preintermediate}` })
            : '',
        4: isLgOrHigher
            ? intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.intermediate}` })
            : '',
        5: intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.expert}` }),
    };
    react_1.default.useEffect(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange({ id: tagId, value: (value === null || value === void 0 ? void 0 : value.value) || min });
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.RatingSlider, { defaultValue: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) || min, marks: marks, min: min, max: max, step: 1, onChange: sliderValue => onChange === null || onChange === void 0 ? void 0 : onChange({ id: tagId, value: sliderValue }), value: (value === null || value === void 0 ? void 0 : value.value) || 1, range: false, tooltipVisible: false }));
};
exports.SkillTagRatingSlider = SkillTagRatingSlider;
